function filter(category) {
    const nodes = document.querySelectorAll('[data-categories]');

    for (const node of nodes) {
        node.style.removeProperty('--animation-order');

        if (!category) {
            node.setAttribute('filtered', 'false');
            continue;
        }

        const nodeCategories = node.getAttribute('data-categories')
            .split(',')
            .map(_ => _.trim());

        const hasCategory = nodeCategories.indexOf(category) > -1;
        if (hasCategory) {
            node.setAttribute('filtered', 'false');
        } else {
            node.setAttribute('filtered', 'true');
        }
    }
}
